import BaseAPI from '@/services/api/internal/tools/baseAPI';

const LogbooksAPI = new BaseAPI({
  url: `${process.env.MYPREDITY_BASE_URI}/logbooks`,
});

export default LogbooksAPI;
